import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class CorreoCargador {
  // Correo electronico cargadores
  static getCorreoCargador (cargador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_correo_cargador?r=` +
        `{"clave":{"cargador": ${cargador}},"limite":1,"orden": ["id"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static enviarCuposACargadores (cupo, correoCargador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_cupos_a_cargadores?r=` +
        `{"parametros": {"cargador": ${cupo.cargador}, "corredor": ${cupo.corredor}, "cereal": "${cupo.cereal}",
        "cantidad_asignada": ${cupo.cantidad_asignada}, "fecha_de_emision": "${cupo.fecha_de_emision}",
        "exportador": ${cupo.exportador}, "correo": "${correoCargador}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarResumenCuposACargadores (cupo, correoCargador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_resumen_cupos_a_cargadores?r=` +
        `{"parametros": {"cargador": ${cupo.cargador}, "corredor": ${cupo.corredor},
        "cereal": "${cupo.cereal}", "exportador": ${cupo.exportador}, "correo": "${correoCargador}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarModificacionCuposACargadores (cupo, cantidadAnterior, correoCargador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_modificacion_cupos_a_cargadores?r=` +
        `{"parametros": {"cargador": ${cupo.cargador}, "corredor": ${cupo.corredor}, "cereal": "${cupo.cereal}",
        "cantidad_anterior": ${cantidadAnterior}, "cantidad_asignada": ${cupo.cantidad_asignada}, "fecha_de_emision": "${cupo.fecha_de_emision}",
        "exportador": ${cupo.exportador}, "correo": "${correoCargador}" }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static enviarTotalCuposACargadores (cargador) {
    const axios = getAxiosInstance()
    const promise = axios.get(`enviar_total_cupos_a_cargadores?r=` +
        `{"parametros": {"cargador": ${cargador} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data)
  }

  static eliminarCorreoCargador (id) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`correo_cargador?r=` +
        `{"clave": {"id": ${id} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static buscarCorreoCargador (id) {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_contacto_cargador?r=` +
        `{"clave": {"id": ${id} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => result.data[0])
  }

  static agregarCorreoCargador (nombre, correo, cargador) {
    const axios = getAxiosInstance()
    const promise = axios.post(`correo_cargador`,
      `{"valores": {"nombre": "${nombre}",
      "cargador": ${cargador}, "correo_electronico": "${correo}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static actualizarCorreoCargador (id, nombre, correo, cargador) {
    const axios = getAxiosInstance()
    const promise = axios.put(`correo_cargador`,
      `{"valores": {"nombre": "${nombre}", "cargador": ${cargador}, 
      "correo_electronico": "${correo}"}, "clave": {"id": ${id}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }

  static modificarCorreoCargador (correo, cargador) {
    const axios = getAxiosInstance()
    const promise = axios.put(`modificacion_correo_cargador`,
      `{"valores": {"correo_electronico": "${correo}"}, "clave": {"cargador": ${cargador}}}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result })
  }
}

export default CorreoCargador
